import MobileObjectGroups from './MobileObjectGroups'

export default MobileObjectGroups;